module.exports = __webpack_public_path__ + "img/portret_mobile_graphic.29df0199.png";